import { UtilityService } from './utility.service';
import { MainViewController } from '../ui-components/usercentrics-button/main-view-controller';
import { DataService } from './utilities/data.service';
import { Consent } from '../dataTypes/type-consent';

export default class CrossDomainConsentSharingService {
    private _crossDomainConsentSharingIsActive: boolean;
    private _crossDomainConsentSharingUrl: string;
    private _crossDomainConsentsArray: any[] = [];
    private _crossDomainConsentsExist: boolean;
    private _utilityService: UtilityService;
    private cdcsPreviousData: any;
    private CDCS_IFRAME_HTML_PAGE = 'cdcs-iframe-index.html';
    private iframeInitialization = { isInitialized: false, firstTimeStateSaved: null };
    private iframeOrigin: any;
    private iframeSource: any;
    private iframeInsertionPending = false;
    private globalWindowEvent;
    public updateConsentsAfterGettingTemplates: boolean = false;

    get crossDomainConsentArray(): any[] {
        return this._crossDomainConsentsArray;
    }

    get settingsService() {
        return this.utilityService.settingsService;
    }

    get crossDomainConsentSharingIsActive(): boolean {
        return this._crossDomainConsentSharingIsActive;
    }

    get crossDomainConsentsExist(): boolean {
        return this._crossDomainConsentsExist;
    }

    get utilityService() {
        return this._utilityService;
    }

    constructor(utilityService) {
        this._utilityService = utilityService;
        this.globalWindowEvent = document.createEvent('HTMLEvents');
    }

    initializeIframeEventListner(firstTimeStateSaved) {
        if (!this.iframeInitialization.isInitialized) {
            this.utilityService.developmentLog('iframe event listener initialized');
            this.iframeInitialization.isInitialized = true;
            this.iframeInitialization.firstTimeStateSaved = firstTimeStateSaved;
            window.addEventListener('message', (payload) => {
                if (payload.data.cdcs) {
                    if (this.cdcsPreviousData && this.cdcsPreviousData === JSON.stringify(payload.data.cdcs)) {
                        return;
                    }
                    this.cdcsPreviousData = payload.data.cdcs;
                    // it check if iframe has the settingId or not
                    if (this.cdcsPreviousData.firstTimeNotification) {
                        this.sendSettingId(this.cdcsPreviousData, payload);
                    } else if (this.cdcsPreviousData.consentsData && this.cdcsPreviousData.consentsArray && this.cdcsPreviousData.consentsArray.length) {
                        this.utilityService.developmentLog('Received consents from IFrame');
                        this.utilityService.developmentLog('', this.cdcsPreviousData);
                        this._crossDomainConsentsArray = this.cdcsPreviousData.consentsArray;
                        if (this._crossDomainConsentsArray.length) {
                            DataService.storeGlobally('controllerId', this._crossDomainConsentsArray[0].controllerId);
                            if (DataService.consents && DataService.consents.length && DataService.consentTemplates) {
                                this.utilityService.cDCSyncService.syncConsentDataWithCdcsIframeWhenConsentsAreNotReset();
                            } else {
                                this.updateConsentsAfterGettingTemplates = true;
                            }
                        }
                        setTimeout(() => {
                            if (this.utilityService.settingsService.mainViewController) {
                                this.utilityService.developmentLog('Update main view controller because we received consents from cdcs');
                                MainViewController.update();
                            }
                        }, 100);
                    }
                }
            });
        } else if (
            this.iframeInitialization.firstTimeStateSaved !== null &&
            this.iframeInitialization.firstTimeStateSaved !== firstTimeStateSaved
        ) {
            this.firstTimeStateSaved(firstTimeStateSaved);
        }
    }

    sendSettingId(cdcsEvent, payload) {
        this.iframeSource = payload.source;
        this.iframeOrigin = payload.origin;

		/** 
		 * This is the first time notification that is received from the iframe giving all the settingsIdArray.
		 * We search in the array whether the settings id already exists.
		 * And later on we send the settingsId back to the iframe so the iframe can initialize accordingly.
		 */

        const settingsId = window.usercentrics.settingsId;
        const cdcsSettingsIdArray = cdcsEvent.settingsIdArray;

        this.globalWindowEvent.initEvent('crossDomainConsentFirstTimeNotification', true, true);

        if (
            cdcsSettingsIdArray.map(function (e) {
                return e.settingsId;
            }).indexOf(settingsId) === -1
        ) {
            this._crossDomainConsentsExist = false;
            this.globalWindowEvent.crossDomainConsentsExist = false;
            this.globalWindowEvent.firstTimeStateSaved = this.iframeInitialization.firstTimeStateSaved;

            this.utilityService.developmentLog('first time for this setting id');
        } else {
            this._crossDomainConsentsExist = true;
            const index = cdcsSettingsIdArray.map(function (e) {
                return e.settingsId;
            }).indexOf(settingsId);

            this.globalWindowEvent.crossDomainConsentsExist = true;
            this.globalWindowEvent.firstTimeStateSaved = cdcsSettingsIdArray[index].firstTimeStateSaved;
            this.utilityService.developmentLog('not the first time for this setting id');
        }

        window.dispatchEvent(this.globalWindowEvent);

        this.utilityService.developmentLog('settingId sending', payload.source);

        if (!(typeof MessagePort === 'function' && payload.source instanceof MessagePort) &&
            !(typeof ServiceWorker === 'function' && payload.source instanceof ServiceWorker)) {
            this.utilityService.developmentLog('settingId sent');
            const settingIds = window.usercentrics.settingsIds ? window.usercentrics.settingsIds.split(':') : [window.usercentrics.settingsId];
            settingIds.forEach(settingsId => {
                const cdcsObject = {
                    cdcs: {
                        settingsData: true,
                        settingsId: settingsId,
                        firstTimeStateSaved: this.iframeInitialization.firstTimeStateSaved,
                    },
                };

                payload.source.postMessage(cdcsObject, payload.origin);
            });
        }
    }

    firstTimeStateSaved(value: boolean) {
        if (this.iframeInitialization.firstTimeStateSaved !== null &&
            this.iframeInitialization.firstTimeStateSaved === value) {
            return;
        }

        this.iframeInitialization.firstTimeStateSaved = value;
        if (this.crossDomainConsentSharingIsActive) {

            if (this.iframeSource) {
                const settingIds = window.usercentrics.settingsIds ? window.usercentrics.settingsIds.split(':') : [window.usercentrics.settingsId];
                settingIds.forEach(settingsId => {
                    const cdcs = { cdcs: { firstTimeStateSaved: value, settingsId: settingsId } };
                    this.iframeSource.postMessage(cdcs, this.iframeOrigin);
                });
            } else {
                const consentsharingframeId: HTMLIFrameElement = document
                    .getElementById('cross-domain-consent-sharing-iframe') as HTMLIFrameElement;

                if (consentsharingframeId) {
                    const settingIds = window.usercentrics.settingsIds ? window.usercentrics.settingsIds.split(':') : [window.usercentrics.settingsId];
                    settingIds.forEach(settingsId => {
                        consentsharingframeId.contentWindow.postMessage({ cdcs: { firstTimeStateSaved: value, settingsId: settingsId } }, '*');
                    });
                }
            }
        }
    }

    turnOnCrossDomainConsentSharing(firstTimeStateSaved, crossDomainConsentSharingUrl?) {
        // If we are waiting for the Iframe to load, we don't need this function again
        if (this.iframeInsertionPending) {
            this.utilityService.developmentLog('Iframe appending is pending, ending function');
            return;
        }

        this._crossDomainConsentSharingIsActive = true;
        this.initializeIframeEventListner(firstTimeStateSaved);
        const crossDomainConsentSharingIframe = document.createElement('iframe');
        crossDomainConsentSharingIframe.style.display = 'none';
        crossDomainConsentSharingIframe.style.height = '1px';
        crossDomainConsentSharingIframe.style.width = '1px';
        crossDomainConsentSharingIframe.style.position = 'fixed';
        crossDomainConsentSharingIframe.style.bottom = '0';
        crossDomainConsentSharingIframe.style.left = '0';
        crossDomainConsentSharingIframe.setAttribute('id', 'cross-domain-consent-sharing-iframe');
        if (window.usercentrics.paths && window.usercentrics.paths.crossDomainConsentSharingIFrame) {
            this.crossDomainConsentSharingUrl = window.usercentrics.paths.crossDomainConsentSharingIFrame;
            crossDomainConsentSharingIframe.setAttribute('src', this.crossDomainConsentSharingUrl);
        } else if (window.localhost) {
            this.crossDomainConsentSharingUrl = this.CDCS_IFRAME_HTML_PAGE;
            crossDomainConsentSharingIframe.setAttribute('src', `./${this.crossDomainConsentSharingUrl}`);
        } else if (this.settingsService.settings.consentSharingIFrameIsCustomUrl) {
            this.crossDomainConsentSharingUrl = crossDomainConsentSharingUrl;
            crossDomainConsentSharingIframe.setAttribute('src', this.crossDomainConsentSharingUrl);
        } else {
            this.crossDomainConsentSharingUrl = window.usercentrics.baseUrl;
            window.usercentrics.version = window.usercentrics.version ? window.usercentrics.version : 'sit';
            crossDomainConsentSharingIframe.setAttribute('src', `${this.crossDomainConsentSharingUrl}/${window.usercentrics.version}/${this.CDCS_IFRAME_HTML_PAGE}`);
        }

        if (!document.getElementById('cross-domain-consent-sharing-iframe')) {
            this.utilityService.developmentLog('Appending IFrame to body');

            if (!document.body) {
                this.utilityService.developmentLog('Body not ready, use event listener');
                this.iframeInsertionPending = true;
                document.addEventListener('DOMContentLoaded', () => {
                    this.utilityService.developmentLog('Event listener called, appending IFrame');
                    document.body.appendChild(crossDomainConsentSharingIframe);
                    this.iframeInsertionPending = false;
                });
            } else {
                document.body.appendChild(crossDomainConsentSharingIframe);
            }
        } else {
            this.utilityService.developmentLog('IFrame already existing');
        }
    }

    turnOffCrossDomainConsentSharing() {
        this._crossDomainConsentSharingIsActive = false;
        CrossDomainConsentSharingService.removeCrossDomainConsentSharingIframe();
    }

    static removeCrossDomainConsentSharingIframe() {
        const crossDomainConsentSharingIframe = document.getElementById('cross-domain-consent-sharing-iframe');
        if (crossDomainConsentSharingIframe) {
            document.body.removeChild(crossDomainConsentSharingIframe);
        }
    }

    public set crossDomainConsentSharingUrl(crossDomainConsentSharingUrl) {
        this._crossDomainConsentSharingUrl = crossDomainConsentSharingUrl;
    }

    public get crossDomainConsentSharingUrl() {
        return this._crossDomainConsentSharingUrl;
    }

    public updateIframeStorageToLatest(arrayOfConsentsThatHaveChanged: Consent.Consent[]) {
        if (this.crossDomainConsentSharingIsActive) {

            const settingIds = window.usercentrics.settingsIds ? window.usercentrics.settingsIds.split(':') : [window.usercentrics.settingsId];
            settingIds.forEach(settingsId => {
                const cdcsEvent = {
                    cdcs: {
                        consentsUpdated: true,
                        arrayOfConsentsThatHaveChanged: arrayOfConsentsThatHaveChanged,
                        settingsId: settingsId
                    },
                };
                this.utilityService.developmentLog(`Sending changed consents to iframe for setting ${settingsId}`, cdcsEvent);

                if (this.iframeOrigin && this.iframeSource) {
                    this.iframeSource.postMessage(cdcsEvent, this.iframeOrigin);
                } else {
                    const consentsharingframeId: HTMLIFrameElement = document
                        .getElementById('cross-domain-consent-sharing-iframe') as HTMLIFrameElement;
                    consentsharingframeId.contentWindow.postMessage(cdcsEvent, '*');
                }

            });

            //now since the iframe consents have been updated, we can set this variable to true were it false.
            this.utilityService.developmentLog('setting cross domain consent exist to true');
            this._crossDomainConsentsExist = true;
        }
    }
}
